import { render } from "./registration-account-activation.vue?vue&type=template&id=e9e654a6&scoped=true"
import script from "./registration-account-activation.vue?vue&type=script&lang=js"
export * from "./registration-account-activation.vue?vue&type=script&lang=js"

import "./registration-account-activation.vue?vue&type=style&index=0&id=e9e654a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9e654a6"]])

export default __exports__